import { compose } from 'recompose';

import LoginFormView from './LoginFormView';

export default compose()(LoginFormView);
